// @ts-check
import NoteInput from './NoteInput';

export default NoteInput;
